import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Modal, Spin, message } from "antd";
import { BellOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import { formatTime } from '../constant';
import { submitExam } from '../api';
import { QuestionListItem, TestInfo } from '../types';

const { confirm } = Modal;
let timer: any = 0;
interface IProps {
  testInfo: TestInfo,
  textFontSize: number;
  setTextFontSize: (val: number) => void;
  questionList: QuestionListItem[];
}

function ProcessInfo({ textFontSize, setTextFontSize, questionList, testInfo }: IProps) {
  const [timeLength, setTimeLength] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const urlParams: { id: string } = useParams();
  const history = useHistory();

  function interval(time: number) {
    let _time = time;
    timer = setInterval(() => {
      if (_time === 0) {
        handleSubmit();
        clearInterval(timer);
        return;
      }
      _time = _time - 1;
      setTimeLength(_time);
    }, 1000)
  }

  useEffect(() => {
    if (testInfo.time > 0) {
      let time = (testInfo.time * 60) - (testInfo.curTime - testInfo.startTime);
      interval(time);
    }
    return () => {
      clearInterval(timer)
    };
  }, [testInfo])

  function changeFontSize(type: 'add' | 'reduce') {
    let _size = textFontSize;
    if (type === 'add') {
      _size += 1;
    } else {
      _size -= 1;
    }
    if (_size < 12 || _size > 20) {
      return;
    }
    setTextFontSize(_size);
  }

  function computedLength() {
    let step = 0, total = 0;
    questionList && questionList.map(test => {
      if (test.questions) {
        total += test.questions.length;
        test.questions.map(ques => {
          if (ques.myAnswer) {
            step += 1;
          }
        })
      }
    })
    return `${step} / ${total}`;
  }

  function handleSubmit() {
    const userinfo: any = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    setIsLoading(true);
    submitExam({ examID: urlParams.id, user_id: userinfo.id }).then((res: any) => {
      console.log(res);
      if (res && res.code === 0) {
        const { id } = res.data;
        setIsLoading(false);
        history.push(`/exam_result/${testInfo.mark}/${id}/${urlParams.id}`);
      } else {
        setIsLoading(false);
        res && message.error(res.msg || '提交失败');
      }
    })
  }

  function showConfirm() {
    let isFinish = questionList.every(item => {
      return item.questions.every(item2 => item2.myAnswer !== '');
    })
    confirm({
      title: isFinish ? '是否现在交卷?' : '有试题未完成，是否现在交卷?',
      icon: <ExclamationCircleOutlined />,
      zIndex: 10001,
      onOk() {
        handleSubmit();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  return (
    <>
      {
        isLoading && (
          <div className="test-submit">
            <div className="inner">
              <h1>交卷中</h1>
              <Spin size="large" />
              <div className="text">正在提交答案...</div>
            </div>
          </div>
        )
      }

      <div className="content-right">
        <ul className="menu-items">
          <li className="menu-item menu-item-time">
            <div className="item-label">剩余时间</div>
            <div className="item-value">{formatTime(timeLength)}</div>
          </li>
          <li className="menu-item menu-item-process">
            <div className="item-label">当前进度</div>
            <div className="item-value">{computedLength()}</div>
          </li>
          <li className="menu-item menu-item-fontsize">
            <div className="icon" onClick={() => changeFontSize('reduce')}>-</div>
            <span>字号</span>
            <div className="icon" onClick={() => changeFontSize('add')}>+</div>
          </li>
          <li className="menu-item menu-item-remind">
            <div className="icon"><BellOutlined /></div>
            <div>提醒记录</div>
          </li>
        </ul>
        <Button type="primary" onClick={showConfirm}>提交试卷</Button>
      </div>
    </>
  )
}

export default ProcessInfo;
